require('./fontawesome');
require('./bootstrap');

// 各ページ毎のJS
require('./pages/auth/register/index');
require('./pages/official/index');
